import { css } from 'react-emotion';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import SelectField from './SelectField';
import { MERCHANTS } from '../../../../constants/transactorType';
import { selectors as identitySelectors } from '../../../../reducers/identities';
import StepTitle from '../../../common/StepTitle';
import validate from './validate';
import { withTranslation } from 'react-i18next';
import { getPricingArchVersion } from '../../../../services/PricingArchInfo';
import { PRICING_ARCH_V2 } from '../../../../constants/priceArchs';

export const NEW = 'NEW';
export const EXISTING = 'EXISTING';

const partyHeaderStyle = css({
  fontSize: '20px',
  marginBottom: '35px',
  marginTop: '0',
  textAlign: 'center'
});

const formGroupStyle = css({
  marginBottom: '5px'
});

const selectStyle = css({
  maxWidth: '500px',
  margin: '0px auto',
  marginBottom: '60px',
  minHeight: '81px',
  '& > .form-group': formGroupStyle
});

const buttonStyle = css({
  textAlign: 'right'
});

class SelectPartyStep extends PureComponent {
  static propTypes = {
    fulfillerOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
    authorizedMerchantOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    seller: PropTypes.object
  };

  state = {
    isSubmitDisabled: false
  };

  resetSkus = newSeller => {
    const { seller, updateField } = this.props;

    if (seller && (!newSeller || newSeller.id !== seller.id)) {
      updateField('skus', []);
    }
  };

  priceArchValidatorCallBack = async selectFeildResponse => {
    let architectureVersion;

    if (selectFeildResponse && selectFeildResponse.accountId) {
      architectureVersion = await getPricingArchVersion(selectFeildResponse.accountId);
    }

    if (architectureVersion && architectureVersion.toLowerCase() === PRICING_ARCH_V2.toLowerCase()) {
      this.setState({ isSubmitDisabled: true });
    } else {
      this.setState({ isSubmitDisabled: false });
    }
  };

  render() {
    const { fulfillerOptions, authorizedMerchantOptions, handleSubmit, t } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div>
          <StepTitle icon="start-contract-l" title={t('createContract:getStarted.header')} />
          <h4 className={partyHeaderStyle}>{t('createContract:getStarted.selectBuyer')}</h4>
          <Field
            component={SelectField}
            label={t('common:commonTerminology.buyer')}
            name="buyer"
            options={authorizedMerchantOptions}
            className={selectStyle}
            t={t}
          />
          <h4 className={partyHeaderStyle}>{t('createContract:getStarted.selectBuyingFrom')}</h4>
          <Field
            component={SelectField}
            onChange={this.resetSkus}
            label={t('common:commonTerminology.seller')}
            name="seller"
            options={fulfillerOptions}
            sellerMigratedClass={this.state.isSubmitDisabled ? 'Select-control-error' : null}
            className={selectStyle}
            sellerNameCallback={this.priceArchValidatorCallBack}
            t={t}
          />
          <div className={buttonStyle}>
            <input
              type="submit"
              className="btn btn-primary"
              disabled={this.state.isSubmitDisabled}
              value={t('common:commonWords.next')}
            />
          </div>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  const identityType = MERCHANTS;
  const formSelector = formValueSelector('buyerCreateFlow');

  return {
    fulfillerOptions: identitySelectors.getAvailableCounterParties(state, identityType),
    authorizedMerchantOptions: identitySelectors.getAuthorizedMerchantOptions(state),
    seller: formSelector(state, 'seller')
  };
}

const mapDispatchToProps = dispatch => ({
  updateField: (field, newValue) => dispatch(change('buyerCreateFlow', field, newValue))
});

SelectPartyStep = reduxForm({
  form: 'buyerCreateFlow',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(SelectPartyStep);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(SelectPartyStep));
